module.exports = __webpack_public_path__ + "img/logo-nancy-open-air.95997c8.png";